import { Component } from '@angular/core';

@Component({
  selector: 'app-portal-toolbar',
  templateUrl: './portal-toolbar.component.html',
  styleUrls: ['./portal-toolbar.component.scss'],
})
export class PortalToolbarComponent {}
